import { render, staticRenderFns } from "./merchants-view.vue?vue&type=template&id=db474cd4&scoped=true&"
import script from "./merchants-view.vue?vue&type=script&lang=js&"
export * from "./merchants-view.vue?vue&type=script&lang=js&"
import style0 from "./merchants-view.vue?vue&type=style&index=0&id=db474cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db474cd4",
  null
  
)

export default component.exports